// extracted by mini-css-extract-plugin
export default {"container":"sea_container__BYYdt","toggleButton":"sea_toggleButton__XRdYK","searchInput":"sea_searchInput__0p+OK","open":"sea_open__jzV+U","closed":"sea_closed__NnF+i"};